<script>
import Basic from '../components/basic.vue';
import mixin from '../mixin';
import { planTypes } from '@/common/constants';
export default {
    props: {
        configPlanTileStatus: {
            type: Object,
            default: () => ({}),
        },
        isAddon: {
            type: Boolean,
            default: false,
        }
    },
    mixins: [mixin],
    render(createElement) {
        const { $props, $data, $listeners } = this;
        return createElement(Basic, {
            key: planTypes[planTypes.ADDITIONAL_HOST],
            props: { ...$props, ...$data },
            on: $listeners
        });
    },
};
</script>
